/* The KANON switch — `.tog`, 40 x 22, a pill with an 18px knob, drawn once for every surface that
 * wears one (the report editor and list, the booking settings and week pattern). What a press MEANS
 * — staged or written at once — is the caller's, and `Toggle` names it accordingly. */
.tog {
  position: relative;
  flex: none;
  width: var(--sz-toggle-w);
  height: var(--sz-toggle-h);
  padding: var(--space-0);
  background: var(--accent-grad);

  /* Split into three, for `.chip`'s reason: the OFF state paints this edge and the ON state must
   * not be a pixel taller for having none. */
  border-width: var(--border-hairline);
  border-style: solid;
  border-color: transparent;
  border-radius: var(--r-pill);
  cursor: pointer;
}

.tog::after {
  content: '';
  position: absolute;
  top: var(--space-1px);
  right: var(--space-1px);
  width: var(--sz-toggle-knob);
  height: var(--sz-toggle-knob);
  background: var(--on-accent-grad);
  border-radius: var(--r-circle);
}

.togOff {
  background: var(--bg-sunken);
  border-color: var(--border-canon-edge);
}

.togOff::after {
  right: auto;
  left: var(--space-1px);
  background: var(--text-3);
}

/* Held on and not movable — the intake's four locked questions. A NEUTRAL step above the chip
 * ground, because a refusal is not an accent and an orange switch nobody may touch reads as an
 * invitation. The reason travels with it in the tree; see `Toggle`. */
.togLock {
  background: var(--bg-lock);
  border-color: transparent;
  cursor: not-allowed;
}

.togLock::after {
  right: var(--space-1px);
  left: auto;
  background: var(--text-2);
}

.tog:focus-visible {
  outline: var(--border-focus) solid var(--text);
  outline-offset: var(--space-2px);
}
